import toast from "react-hot-toast";
import { withTranslation } from "react-i18next";

import { styled } from "simplydo/react/styled";
import { Button, Icon, Table } from "simplydo/react/ui";

import api from "api";

import type { IdeaCompanyVerificationProps } from "./types";

const VerificationContainer = styled.div`
  border-radius: 5px;
  box-shadow:
    0 0 0 1px #d4d4d5,
    0 2px #16ab39,
    0 1px 3px #bcbdbd;
  padding: 15px;
  > .header {
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

function IdeaCompanyVerification({
  idea,
  report,
  updateReportUrl,
  field,
}: IdeaCompanyVerificationProps) {
  if (!report || !idea) return null;
  return (
    <VerificationContainer>
      <div className="header">
        <Icon name="check circle" color="green" /> Company successfully found
      </div>
      <Table basic="very">
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell collapsing>Name</Table.HeaderCell>
            <Table.Cell>{report.companyName}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell collapsing>Registration</Table.HeaderCell>
            <Table.Cell>{report.companyNumber}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell collapsing>Address</Table.HeaderCell>
            <Table.Cell>{report.companyAddress}</Table.Cell>
          </Table.Row>
          {report.companyVatNumber && (
            <Table.Row>
              <Table.HeaderCell collapsing>VAT number</Table.HeaderCell>
              <Table.Cell>{report.companyVatNumber}</Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
      {report.reportVisible ? (
        report.reportUrl ? (
          <Button
            as="a"
            href={report.reportUrl || report.tempReportUrl}
            target="_blank"
            rel="noopener noreferrer"
            download="report.pdf"
            fluid
            primary
            icon="download"
            content="Download report"
          />
        ) : (
          <Button
            onClick={() => {
              api.verifications.createReport(
                {
                  id: report.companyId || report.report || report._id,
                  forType: "idea",
                  forId: idea._id,
                  templatedFieldId: field.id,
                },
                (data: import("./types").CreditsafeCreateReportResponse) => {
                  const reportUrl =
                    data?.report?.tempReportUrl ?? data?.report?.reportUrl;
                  if (reportUrl) {
                    toast.success("Report generated successfully");
                    updateReportUrl(reportUrl);
                    window.open(reportUrl, "_blank");
                  } else {
                    toast.error("Failed to generate report");
                  }
                },
                () => {
                  toast.error("Failed to generate report");
                },
              );
            }}
            fluid
            primary
            icon="download"
            content="Download report"
          />
        )
      ) : null}
    </VerificationContainer>
  );
}

export default withTranslation()(IdeaCompanyVerification);
